module.exports = "/img/vdf_logo.png?bd69301e291d48a8712e7599d1d20cac";